"use client"

import type { ReactNode } from "react"
import type { AllNameSpaces, ClientTrans } from "#modules/localization/translations"
import type { KeyPrefix } from "i18next"
import type { FallbackNs, UseTranslationResponse } from "react-i18next"

import { createInstance } from "i18next"
import { I18nextProvider, useTranslation as useTranslation_Reacti18Next } from "react-i18next"

import { rawInitTranslations } from "#modules/localization/translations"

export function TranslationsProvider({ children, clientTrans }: { children: ReactNode; clientTrans: ClientTrans }) {
  const i18n = createInstance()

  const generatedClientNamespaces = clientTrans.clientNameSpaces.filter(ns => ns.includes("-client-generated"))
  for (const locale of Object.keys(clientTrans.clientResources)) {
    for (const ns of generatedClientNamespaces) {
      // @ts-ignore
      clientTrans.clientResources[locale] = { ...clientTrans.clientResources[locale], ...(clientTrans.clientResources[locale][ns] as object) } as Record<string, any>
      delete clientTrans.clientResources[locale][ns]
    }
  }

  void rawInitTranslations({ locale: clientTrans.locale, resources: clientTrans.clientResources, i18nInstance: i18n, namespaces: clientTrans.clientNameSpaces })

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
}

/**
 * Namespace param is only for correct type inference
 */
export function useTranslation<
  TNamespace extends AllNameSpaces[],
  KPrefix extends KeyPrefix<FallbackNs<TNamespace>> = undefined,
  Return = UseTranslationResponse<FallbackNs<TNamespace>, KPrefix>,
>(...namespace: TNamespace): Return {
  const result = useTranslation_Reacti18Next()
  // TODO
  // // Security check that requested namespace is actually passed from the server to the client in the code - language is irrelevant, therefore only defaultLocale is checked
  // for (const ns of namespace) {
  //   if (!result.i18n.hasResourceBundle(i18nConfig.defaultLocale, ns)) {
  //     throw new Error(
  //       `Client Namespace >>>>> ${ns} <<<<< not loaded - Make sure the namespace used is loaded inside server component with await translations and passed via TranslationsProvider to the client component.`
  //     )
  //   }
  // }

  const clone = result.i18n.cloneInstance({ defaultNS: namespace[0] })
  return { i18n: clone, t: clone.t } as Return
}
